export const validateGroupName = (name: string) => {
  switch (name) {
    case 'periodoIds':
      return 'periodo'
    case 'periodoSelectIds':
      return 'periodo'
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'
    case 'fornecedorIds':
      return 'fornecedor'
    case 'fornecedorSelectIds':
      return 'fornecedor'
    case 'gerenteProdutoIds':
      return 'gerenteProduto'
    case 'gerenteProdutoSelectIds':
      return 'gerenteProduto'
    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'
    case 'gerenteCategoriaIds':
      return 'gerenteCategoria'
    case 'gerenteCategoriaSelectIds':
      return 'gerenteCategoria'
    case 'subCategoriaIds':
      return 'subCategoria'
    case 'subCategoriaSelectIds':
      return 'subCategoria'
    default:
      return null
  }
}
